import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import utilities from '@/core/utilities';
import { successToast } from '@/utilities/toast.utilities';
import { faCopy } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Button } from '@seeqdev/qomponents';

export const CopyBranchCode = ({ text, branchCode }: { text: string; branchCode: string }) => {
  const { t } = useTranslation();

  const copyBranchCodeToClipboard = async (code: string) => {
    if (!code) return;

    await utilities.copyTextToClipboard(code);
    successToast({
      messageKey: 'HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_SUCCESS',
      messageParams: { branchCode: code },
    });
  };

  return (
    <div className={stylex.props(homeStyles.content).className}>
      <span className={stylex.props(homeStyles.copyButton).className}>{t(text)}</span>
      <span className={stylex.props(homeStyles.code).className}>{branchCode}</span>
      <Button
        tooltip={t('HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_TOOLTIP')}
        icon={faCopy}
        iconStyle="text"
        variant="no-border"
        xstyle={[homeStyles.copyAction]}
        testId="copyBranchCodeButton"
        onClick={() => copyBranchCodeToClipboard(branchCode)}
      />
    </div>
  );
};

const homeStyles = stylex.create({
  copyAction: { color: 'var(--sq-light-gray)' },
  content: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: '0rem',
    alignItems: 'center',
    gap: '0.25rem',
  },
  copyButton: {
    flexShrink: 0,
  },
  code: {
    backgroundColor: 'var(--sq-homescreen-branch-code)',
    borderRadius: 3,
    paddingLeft: 3,
    paddingRight: 3,
    whiteSpace: 'nowrap',
    minWidth: '0rem',
    flex: '0 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});
